export default __webpack_public_path__ + "static/media/ic_arbitrum_16.7fee3885.svg";